/* eslint-disable */
import da from 'date-fns/esm/locale/da/index.js';
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
  GetAllGroups,
  GetFactoriesByGroupID,
  GetQRTagForQRCode,
  updateStatus
};

async function GetAllGroups() {
  const response = await CommonGet('/api/Group/GetAllGroups', null);
  return response.data;
}

async function GetFactoriesByGroupID(groupID) {
  const response = await CommonGet(
    '/api/Factory/GetFactoriesByGroupID',
    'groupID=' + parseInt(groupID)
  );
  return response.data;
}
async function GetQRTagForQRCode(groupID, operationEntityID) {
  const response = await CommonGet(
    '/api/QRtag/GetQRTagForQRCode',
    'groupID=' + groupID + '&operationEntityID=' + operationEntityID
  );
  return response.data;
}
async function updateStatus(data) {
  const response = await CommonPost('/api/QRtag/UpdateCollectionTagIsPrint', null, data);
  return response;
}

